export default "__VITE_ASSET__eVY9Z_rd__"